import { ReactNode, memo, Fragment } from 'react';
import { Control, FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';

const errorForm: UseFormReturn<FieldValues> = {
  watch() {
    throw new Error('Not inside a form');
  },
  getValues() {
    throw new Error('Not inside a form!');
  },
  getFieldState() {
    throw new Error('Not inside a form!');
  },
  setError() {
    throw new Error('Not inside a form!');
  },
  clearErrors() {
    throw new Error('Not inside a form!');
  },
  setValue() {
    throw new Error('Not inside a form!');
  },
  trigger() {
    throw new Error('Not inside a form!');
  },

  //@ts-expect-error type not needed
  formState: {
    dirtyFields: Object.freeze([]),
    disabled: true,
    errors: Object.freeze({}),
    isDirty: false,
    isLoading: false,
    isSubmitSuccessful: false,
    isSubmitted: false,
    isSubmitting: false,
    isValid: false,
    isValidating: false,
    submitCount: 0,
    touchedFields: Object.freeze([]),
    defaultValues: undefined,
  },
  resetField() {
    throw new Error('Not inside a form!');
  },
  reset() {
    throw new Error('Not inside a form!');
  },
  handleSubmit() {
    throw new Error('Not inside a form!');
  },
  unregister() {
    throw new Error('Not inside a form!');
  },

  //Fake control object, only purpose is to show an error if used outside of a form
  // There may be future changes to useFormHook that require this to be adjusted to have more dummy implmentations in order for it to work

  control: {
    _subscribe: () => {
      return () => {};
    },

    getFieldState() {
      throw new Error('Not inside a form!');
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    _subjects: {},
  } as unknown as Control<FieldValues>,
  register() {
    throw new Error('Not inside a form!');
  },
  setFocus() {
    throw new Error('Not inside a form!');
  },
};
export type FormProviderFixProps = {
  children?: ReactNode;
};

/**
 * Using `useFormState` outside of a Form will cause an error.
 * by setting a fake provider around the whole application we can
 * use `useFormState` in any component freely.
 */
export const FormProviderFix = memo(function FormProviderFix({ children }: FormProviderFixProps) {
  return (
    <FormProvider {...errorForm}>
      <Fragment>{children}</Fragment>
    </FormProvider>
  );
});
